import script from "./HeaderUnicefbelgique.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderUnicefbelgique.vue?vue&type=script&setup=true&lang=js"

import "./HeaderUnicefbelgique.vue?vue&type=style&index=0&id=70f5fe57&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f5fe57"]])

export default __exports__